<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne v-show="noticeInfo.notice_title" class="-margin-md">{{
      noticeInfo.notice_title
    }}</HeadingOne>

    <section>
      <p v-show="noticeInfo.notice_date" class="-textright">
        {{ ymdDateFormat(noticeInfo.notice_date || "", "/") }}
      </p>
      <p
        v-html="noticeInfo.notice_body.replace(/(¥n|\n|¥n¥r|\n\r)/g, '<br/>')"
      ></p>
    </section>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal" router-name="mb002"> メッセージ一覧へ </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { getNoticeInfoLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { ymdDateFormat } from "@/utils/Filter";
import { goToErrorPage } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb003",
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "  ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,メッセージ",
    });

    return {
      ymdDateFormat,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "メッセージ",
          routerName: "mb002",
        },
      ],
      noticeInfo: {
        notice_id: this.$route.params.notice_id,
        status: "",
        account_id: "",
        notice_date: "",
        importance: "",
        notice_title: "",
        notice_body: "",
      },
    };
  },
  mounted() {
    try {
      getNoticeInfoLambdaInvoke(this.noticeInfo)
        .then((res) => {
          let resBody = JSON.parse(res.body);
          for (let key in resBody) {
            if (Object.prototype.hasOwnProperty.call(this.noticeInfo, key)) {
              this.noticeInfo[key] = resBody[key].toString().trim();
            }
          }

          document.title =
            this.noticeInfo.notice_title +
            " | メッセージ一覧 | au PAY スマートローン";
          this.breadcrumbItems.push({
            text: this.noticeInfo.notice_title,
            active: true,
          });
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style scoped></style>
